import * as React from 'react';
import { DispatchContext } from '../../context/context';
import { setDisclaimer } from './actions';
import Disclaimer from './Disclaimer';

const ConnectedDisclaimer = props => {
    const { dispatch } = React.useContext(DispatchContext);

    const setDisclaimerAction = React.useCallback(value => setDisclaimer(dispatch, value), [dispatch]);

    return <Disclaimer setDisclaimer={setDisclaimerAction} {...props} />;
};

export default ConnectedDisclaimer;
